import React, { useState } from "react";
import Disclaimer from "components/Disclaimer";
// import DownloadForm from "components/DownloadForm";
import ReCAPTCHA from "react-google-recaptcha";

import { CLAIM_STATES } from "../libs/state";


const NoPurchase = ({
  recaptchaCode,
  recaptchaRef,
  noPurchaseClaim,
  openNP,
  openTOC,
  artists,
  isVisible = false,
}) => {
  const [npClaimState, setNpClaimState] = useState(CLAIM_STATES[0]);
  const [selectedArtist, setSelectedArtist] = useState(null);

  const handleFormSuccess = (registeredEmail) => {
    noPurchaseClaim({ selectedArtist, registeredEmail });
  };

  const validateNPCaptcha = async () => {
    try {
      // const token = await recaptchaRef.current.executeAsync();
      if (token) {
        noPurchaseClaim(selectedArtist);
      }
    } catch (error) {
      console.log("Captcha error: ", error);
    }
  };

  return (
    <section className="toc" aria-hidden={isVisible}>
      <div className="toc-wrapper no-purchase__wrapper">
        <button className="toc-close" onClick={() => openNP()}>
          close modal
        </button>
        <div className="toc-content no-purchase__content">
          <div className="no-purchase__title">
            {selectedArtist ? (
              <>
                You chose <strong>{selectedArtist.alias}</strong> for your Real
                Meal NFT Game piece
              </>
            ) : (
              <>Choose your meal box to continue</>
            )}
          </div>

          {selectedArtist && (
            <>
              <div className="chosen-box" data-artist={selectedArtist.id} />
              <a
                className="select-another"
                onClick={() => {
                  setNpClaimState(CLAIM_STATES[0]);
                  setSelectedArtist(null);
                }}>
                Select another artist?
              </a>
            </>
          )}

          {(() => {
            switch (npClaimState) {
              case CLAIM_STATES[2]:
                return (
                  <div className="box-claim">
                    <button
                      className="button"
                      data-size="sm"
                      onClick={() => setNpClaimState(CLAIM_STATES[3])}>
                      I accept the rules
                    </button>
                    <p>
                      <a className="sm-text" onClick={() => openTOC()}>
                        Read the rules
                      </a>
                    </p>
                  </div>
                );
              case CLAIM_STATES[3]:
                return (
                  <div className="box-claim">
                    <div className="np__captcha">
                      <ReCAPTCHA
                        theme="dark"
                        onChange={() => noPurchaseClaim(selectedArtist)}
                        sitekey={recaptchaCode}
                      />
                    </div>
                  </div>
                );
              default:
                return (
                  <div className="no-purchase__boxes">
                    <ul>
                      {artists.map((artist, index) => {
                        return (
                          <li
                            key={index}
                            className="box"
                            data-artist={artist.id}
                            onClick={() => {
                              setNpClaimState(CLAIM_STATES[2]);
                              setSelectedArtist(artist);
                            }}>
                            <span className="box__label">{artist.alias}</span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
            }
          })()}
          <div className="you-chose">
            <Disclaimer onRulesClick={() => openTOC()} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NoPurchase;
